import { nullishToOptional } from "../../../helpers";
import { PageBlockV1 } from "./documentation-block-v1";
import { DocumentationItemConfigurationV1 } from "./documentation-v1";
import { z } from "zod";
export const DocumentationPageDataV1 = z.object({
    blocks: z.array(PageBlockV1),
    configuration: nullishToOptional(DocumentationItemConfigurationV1),
});
